var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxArabic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arabic flag icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-LFM-flow-\\u2013-Rewe-case",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Language-selection-\\u2013-LFM-\\u2013-Rewe-\\u2013-mvp",
    transform: "translate(-16.000000, -574.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Body",
    transform: "translate(0.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-arabic",
    transform: "translate(16.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999645,24.0000709 C5.37249841,24.0000709 0,18.6273739 0,11.9998652 C0,5.37241328 5.37249841,0 11.9999645,0 C18.6274448,0 24,5.37241328 24,11.9998652 C24,18.6273739 18.6274448,24.0000709 11.9999645,24.0000709",
    id: "Fill-3",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8645375,6.89978984 C20.9474602,2.82310628 16.8037243,0 11.9999645,0 C7.19636079,0 3.05255398,2.82310628 1.1354767,6.89978984 L22.8645375,6.89978984",
    id: "Fill-4",
    fill: "#21773E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8645375,17.1000399 L1.1354767,17.1000399 C3.05269586,21.1770924 7.19636079,24.0000709 11.9999645,24.0000709 C16.8037243,24.0000709 20.9473183,21.1770924 22.8645375,17.1000399",
    id: "Fill-5",
    fill: "#000105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48098133,0.525479509 C5.27386371,1.50783974 2.55983447,3.86223253 1.1354767,6.89978984 L1.137009,6.89978984 C-0.369227495,10.1024524 -0.369170743,13.8973915 1.137009,17.1000399 L1.1354767,17.1000399 C2.63361187,20.2744543 5.50739754,22.685982 8.89963968,23.593444 L8.89963968,0.406584396 C8.759264,0.444168305 8.61939908,0.483071694 8.48098133,0.525479509 C8.43228825,0.540391056 8.61939908,0.483071694 8.48098133,0.525479509",
    id: "Fill-6",
    fill: "#DA3337"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxArabic);
export default __webpack_public_path__ + "static/media/px-arabic.be5190fa76af370478004c7d57c37fce.svg";
export { ForwardRef as ReactComponent };